// extracted by mini-css-extract-plugin
var _1 = "TablePaginationPages-moduleTablePaginationPages__bYPXC";
var _2 = "TablePaginationPages-moduleactive___D1ln";
var _3 = "TablePaginationPages-moduledisabled__PQaIN";
var _4 = "TablePaginationPages-modulehovered__EYwln";
var _5 = "TablePaginationPages-modulemobile__NLKlR";
var _6 = "TablePaginationPages-modulepage__XIAKC";
export { _1 as "TablePaginationPages", _2 as "active", _3 as "disabled", _4 as "hovered", _5 as "mobile", _6 as "page" }
